import { useEffect, useState } from "react";
import { API } from "@/apiConfig";

// Small square: blue = Central reachable, red = offline. Text only when there is something to say.
export default function CentralStatusIndicator({ compact = false }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const res = await fetch(`${API}/settings/central-status`, {
          credentials: "include",
          headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
        });
        if (alive && res.ok) setStatus(await res.json());
      } catch {
        if (alive) setStatus((s) => (s ? { ...s, online: false } : s));
      }
    };
    poll();
    const t = setInterval(poll, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!status?.central_managed) return null;
  const waiting = (status.pending_events || 0) + (status.pending_files || 0);
  const label = status.online
    ? waiting > 0 ? `Central online — syncing ${waiting}` : "Central online"
    : `Central offline — ${status.pending_events || 0} sales waiting`;

  if (compact) {
    return (
      <span
        className={`inline-block w-3.5 h-3.5 shrink-0 rounded-[2px] ${status.online ? "bg-blue-600" : "bg-red-600 animate-pulse"}`}
        title={label}
        data-testid={status.online ? "central-status-online" : "central-status-offline"}
      />
    );
  }

  return (
    <div className="flex items-center gap-2 px-2 py-1.5" data-testid="central-status-indicator" title={label}>
      <span
        className={`inline-block w-3 h-3 shrink-0 ${status.online ? "bg-blue-600" : "bg-red-600"}`}
        data-testid={status.online ? "central-status-online" : "central-status-offline"}
      />
      <span className={`text-xs font-semibold truncate ${status.online ? "text-zinc-600" : "text-red-700"}`} data-testid="central-status-label">
        {label}
      </span>
    </div>
  );
}
